import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";

import { isUIComponentVisible } from "~/utils";

// Selectors
const getSidebarRight = path(["domain", "ui", "sidebarRight"]);
export const selectSidebarRight = createSelector(getSidebarRight, identity);
export const selectIsSidebarRightVisible = createSelector(
  getSidebarRight,
  isUIComponentVisible
);
export const selectShowMaterialsOnPageTab = createSelector(
  getSidebarRight,
  prop("showMaterialsOnPageTab")
);
export const selectShowAllMaterialsTab = createSelector(
  getSidebarRight,
  prop("showAllMaterialsTab")
);

// Initial State
const initialState = () => ({
  showMaterialsOnPageTab: true,
  showAllMaterialsTab: true
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
